/**
 * Created by bob.gear on 12/11/2015.
 */

angular.module("EICDataStream3.projectDisplay")
  .directive('companyOfficesAndContacts',[ function() {
    return {
      restrict:"A",
      template: "<span ng-hide='company.contacts.length==0' style='font-size:11px;font-weight:bold;'>&nbsp;&nbsp;&nbsp;Contacts:</span>\
    <ul ng-hide='company.contacts.length==0' style='list-style:none;'>\
      <li ng-repeat='contact in company.contacts' style='font-size:8pt;'>\
        <div display-contact contact='contact'></div>\
      </li>\
    </ul>\
<span ng-hide='company.offices.length < 2 && company.contacts.length==0'\
style='font-size:11px;font-weight:bold;'>&nbsp;&nbsp;&nbsp;Offices:</span>\
<ul style='list-style:none;'>\
  <li ng-repeat='office in company.offices' style='font-size:8pt;'>\
  <div display-office-address office='office'></div>\
    <ul ng-hide='office.contacts.length==0'>\
      <li ng-repeat='contact in office.contacts' style='font-size:8pt;'>\
        <div display-contact contact='contact'></div>\
      </li>\
    </ul>\
  </li>\
</ul>",

      scope: { company: "=" }
    };
  }])
  .directive('displayOfficeAddress',[ function() {    return {
      restrict: "A",
      template: "<span ng-bind-html='address | highlightKeywords'></span>",
      scope: { office: "=" },
      link: function($scope, element, attrs){
        $scope.addressLine1 = !($scope.office.addressLine1) ? "" : $scope.office.addressLine1 + ", " ;
        $scope.addressLine2 = !($scope.office.addressLine2) ? "" : $scope.office.addressLine2 + ", " ;
        $scope.addressLine3 = !($scope.office.addressLine3) ? "" : $scope.office.addressLine3 + ", " ;
        $scope.town = !($scope.office.town) ? "" : $scope.office.town + ", " ;
        $scope.county = !($scope.office.county) ? "" : $scope.office.county + ", " ;
        $scope.country = !($scope.office.country) ? "" : $scope.office.country;

        $scope.address = $scope.addressLine1
          + $scope.addressLine2
          + $scope.addressLine3
          + $scope.town
          + $scope.county
          + $scope.county
      }
    }
  }])
  .directive('displayContact',[ function() {
    return {
      restrict: "A",
      template: "<span ng-bind-html='displayName | highlightKeywords'></span>\
        <span ng-bind-html='jobTitle | highlightKeywords'></span>\
        <span ng-bind-html='phoneNumber | highlightKeywords'></span>\
        <span ng-bind-html='emailAddress | highlightKeywords'></span>",
      scope:{ contact: "=" },
      link: function($scope, element, attrs){
        $scope.displayName = !($scope.contact.displayName) ? "" : $scope.contact.displayName + ": " ;
        $scope.jobTitle = !($scope.contact.jobTitle) ? "" : $scope.contact.jobTitle;
        $scope.phoneNumber = !($scope.contact.phoneNumber) ? "" : "<br>tel: " + $scope.contact.phoneNumber;
        $scope.emailAddress = !($scope.contact.emailAddress) ? "" : "<br>" + $scope.contact.emailAddress;
      }
    }
  }]);
